/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
export { ClearRange, PageBlobClearPagesHeaders, PageBlobCopyIncrementalHeaders, PageBlobCreateHeaders, PageBlobGetPageRangesDiffHeaders, PageBlobGetPageRangesHeaders, PageBlobResizeHeaders, PageBlobUpdateSequenceNumberHeaders, PageBlobUploadPagesFromURLHeaders, PageBlobUploadPagesHeaders, PageList, PageRange, StorageError } from "../models/mappers";
//# sourceMappingURL=pageBlobMappers.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@azure/storage-blob/dist-esm/src/generated/src/models/pageBlobMappers.js
// module id = 695
// module chunks = 0